import { StrictMode } from 'react';
import ReactDOM from 'react-dom';

import Layout from './layout';
import reportWebVitals from './reportWebVitals';
import Routes from './Routes';

ReactDOM.render(
  <StrictMode>
    <Layout>
      <Routes />
    </Layout>
  </StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
